import { render, staticRenderFns } from "./o-layered-container-minimal.vue?vue&type=template&id=e0fdff66&"
import script from "./o-layered-container-minimal.vue?vue&type=script&lang=js&"
export * from "./o-layered-container-minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports